export enum IntegrationDataStatusResponse {
  IDLE = 'IDLE',
  ERROR = 'ERROR',
  RESOLVED_CONFLICT_ERROR = 'RESOLVED_CONFLICT_ERROR',
}
